import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Social_benefits.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { saveAs } from 'file-saver';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import Video from '../Video/Video';
import { tableDate, timeToDate } from '../../services/tableDate.service';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import useWindowDimensions from '../hooks/useDimensions';
import "./Social_benefits.css"
import ConfBar from '../ConfBar/ConfBar';
import Base64Downloader from 'common-base64-downloader-react';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { SplitButton } from 'primereact/splitbutton';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_benefits
Description : Pagina de costos contables para el CRUD de las prestaciones sociales del aplicativo remunerlite.
Date Autor Modification
================================================================================
15/10/2021 Cristian Andres Pizo Mina - Pagina de Prestaciones sociales
07/01/2025 Santiago Coca - Se agrega reporte liquidación definitiva - soporte
================================================================================ */

export default function Social_benefits() {
  const toast = useRef(null);
  const [reason_retirement, setReason_retirement] = useState("");
  const [listaCalendario, setListaCalendario] = useState([]);
  const [calendario, setCalendario] = useState([]);
  const [codEmpleado, setCodEmpleado] = useState("");
  const [date_end, setDate_end] = useState("");
  const [updateCodEmpleado, setUpdateCodEmpleado] = useState("");
  const [updateCalendario, setUpdateCalendario] = useState("");
  const [fechaPlano, setFechaPlano] = useState("");
  const [consultado, setConsultado] = useState(false)
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [listaId_lov_reason, setListaId_lov_reason] = useState([]);
  const [updateId, setUpdateId] = useState("");
  const [updateDate_retirement, setUpdateDate_retirement] = useState("");
  const [updateReason_retirement, setUpdateReason_retirement] = useState("");
  const [liquidacion, setLiquidacion] = useState("");
  const [plano, setPlano] = useState("")
  const [listaLiquidacion, setListaLiquidacion] = useState([])
  const [listaPlanoBancario, setListaPlanoBancario] = useState([])
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);
  const setOptions_edit = []
  const setOptions_edit2 = []
  const setOptions_edit3 = []
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [deleteId, setDeleteId] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenLiquidacion, setIsOpenLiquidacion] = React.useState(false);
  const [isOpenPlano, setIsOpenPlano] = React.useState(false);
  const [isOpenReporte, setIsOpenReporte] = React.useState(false);
  const [isOpenReportWorkCertificate, setIsOpenReportWorkCertificate] = React.useState(false);
  const [isOpenReportSeveranceFile, setIsOpenReportSeveranceFile] = React.useState(false);
  const [isOpenReportTerminationSupport, setIsOpenReportTerminationSupport] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const [pdf, setPdf] = useState('')

  const [rowDataLogs, setRowDataLogs] = useState([]);
  const [rowsLogs, setRowsLogs] = useState([]);
  const [first2Logs, setFirst2Logs] = useState(0);
  const [rows2Logs, setRows2Logs] = useState(10);
  const [selectedRowsLogs, setSelectedRowsLogs] = useState(null);
  const [filters1Logs, setFilters1Logs] = useState(null);
  const elementWidth = { width: "20rem" }
  const headers = { authorization: localStorage.getItem('token') }
  const { width } = useWindowDimensions()

  const [rowsPlano, setRowsPlano] = useState([]);

  const [rowReport, setRowReport] = useState([]);

  const [employees, setEmployees] = useState("")
  const [net, setNet] = useState("")

  const [errorRows, setErrorRows] = useState([])
  const [isOpenErrors, setIsOpenErrors] = useState(false)

  const items = [
        {
            label: 'Documento liquidación definitiva',
            icon: 'pi pi-file-pdf',
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={() => { showModalReporte()}} className='p-button-danger p-button-sm text-xs w-full h-full'/>
            }
        },
        {
            label: 'Certificado laboral',
            icon: 'pi pi-file-pdf',
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={() => { showModalReportWorkCertificate()}} className='p-button-danger p-button-sm text-xs w-full h-full'/>
            }
        },
        {
            label: 'Carta retiro de cesantías',
            icon: 'pi pi-file-pdf',
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={() => { showModalReportSeveranceFile()}} className='p-button-danger p-button-sm text-xs w-full h-full'/>
            }
        },
        {
            label: 'Reporte liquidación definitiva - Soporte',
            icon: 'pi pi-file-pdf',
            template: (item, options) => {
                return <Button label={item.label} icon={item.icon} onClick={() => { showModalReportTerminationSupport()}} className='p-button-danger p-button-sm text-xs w-full h-full'/>
            }
        },
    ]

  useEffect(() => {
    const getLists = async () => {
      await apis.getSocial_benefitsLists(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
        let codsEmpleados = res.data["CONTRACTS"]
        let contenidoCodEmpleado = []
        let id_lov_reason = res.data["ID_LOV_REASON"]
        let contenidoId_lov_reason = []
        codsEmpleados.forEach(element => {
          contenidoCodEmpleado.push({ "value": '' + element.CODE + '', "label": '' + element.NAME + '' });
        })
        id_lov_reason.forEach(element => {
          contenidoId_lov_reason.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaCodEmpleado(contenidoCodEmpleado);
        setListaId_lov_reason(contenidoId_lov_reason)
      })
      GetCalendar()
      setTabla();
    }
    getLists()
  }, []);

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  const GetCalendar = async (contract = "") => {

    await apis.getNoveltiesCalendarSB(contract, headers).then(res => {
      let lista = res.data["CALENDAR"]
      let contenidoCalendario = []
      lista.forEach(element => {
        contenidoCalendario.push({ "value": '' + element.ID_CALENDAR + '', "label": '' + element.DETAIL + '' })
      })
      setListaCalendario(contenidoCalendario)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  async function setTabla() {
    await apis.getSocial_benefits(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["TERMINATION"].length > 0) {
        let data = res.data["TERMINATION"]
        let contenidoTabla = []
        console.log(data)
        data.forEach(element => {
          let concepto = element["LOV_REASON"].split("|")
          let datos = element["NAME"].split("|")
          let fecha = tableDate(element.END_DATE)
          contenidoTabla.push({
            TERMINATION_ID: element.TERMINATION_ID, ID_CALENDAR: element.ID_CALENDAR, CONTRACT_ID: element.CONTRACT_ID,
            NUMBER_ID: datos[0], NAME: datos[1], ID_LOV_REASON: concepto[0], LOV_REASON: concepto[1], END_DATE: fecha, STATUS: element.STATUS,
            TOTAL_CONTRACT: element.TOTAL_CONTRACT, TOTAL_REMUNER: element.TOTAL_REMUNER
          })
        })
        setRowData(contenidoTabla)
      } else {
        setRowData([])
      }
      setLoadPage(true)
    }).catch(err => {
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  const showModal = () => {
    setIsOpen(true);
  };

  const hideModal = () => {
    limpiar()
    setIsOpen(false);
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
  };

  const showModalEliminar = (TERMINATION_ID) => {
    setDeleteId(TERMINATION_ID)
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalLiquidacion = (rowData) => {
    caledanrioLiquidacion(rowData)
    setIsOpenLiquidacion(true);
  };

  const hideModalLiquidacion = () => {
    setIsOpenLiquidacion(false)
    setRowsLogs([])
    setFirst2Logs([])
    setRows2Logs([])
    setLiquidacion('')
    setConsultado(false)
    setLoading1(false)
    setLoading2(false)
    setLoading3(false)
  };

  const showModalPlano = (rowData) => {
    calendarioPlano(rowData)
    setIsOpenPlano(true);
  };

  const hideModalPlano = () => {
    setIsOpenPlano(false)
    setPlano('')
    setListaPlanoBancario([])
    setRowsPlano([])
    setFechaPlano('')
  };

  const showModalReporte = () => {
    const _calendario = rowReport.ID_CALENDAR.split('|')
    setCalendario(_calendario[0])
    setCodEmpleado(rowReport.CONTRACT_ID)
    setIsOpenReporte(true);
  };

  const hideModalReporte = () => {
    setIsOpenReporte(false)
    limpiar()
  };

  const showModalReportWorkCertificate = () => {
    const _calendario = rowReport.ID_CALENDAR.split('|')
    setCalendario(_calendario[0])
    setCodEmpleado(rowReport.CONTRACT_ID)
    setIsOpenReportWorkCertificate(true);
  };

  const hideModalReportWorkCertificate = () => {
    setIsOpenReportWorkCertificate(false)
    limpiar()
  };

  const showModalReportSeveranceFile = () => {
    const _calendario = rowReport.ID_CALENDAR.split('|')
    setCalendario(_calendario[0])
    setCodEmpleado(rowReport.CONTRACT_ID)
    setIsOpenReportSeveranceFile(true);
  };

  const hideModalReportSeveranceFile = () => {
    setIsOpenReportSeveranceFile(false)
    limpiar()
  };

  const showModalReportTerminationSupport = () => {
    const _calendario = rowReport.ID_CALENDAR.split('|')
    setCalendario(_calendario[0])
    setCodEmpleado(rowReport.CONTRACT_ID)
    setIsOpenReportTerminationSupport(true);
  };

  const hideModalReportTerminationSupport = () => {
    setIsOpenReportTerminationSupport(false)
    limpiar()
  };

  function inizilaizarData(rowData) {
    let va = rowData.ID_CALENDAR.split("|")[0]
    let la = rowData.ID_CALENDAR.split("|")[1]
    setOptions_edit.push({ "value": '' + va + '', "label": '' + la + '' });
    setOptions_edit2.push({ "value": '' + rowData.ID_LOV_REASON + '', "label": '' + rowData.LOV_REASON + '' });
    setOptions_edit3.push({ "value": '' + rowData.CONTRACT_ID + '', "label": '' + rowData.NAME + '' });
    setUpdateCodEmpleado(setOptions_edit3[0]);
    setUpdateCalendario(setOptions_edit[0]);
    setUpdateReason_retirement(setOptions_edit2[0]);
    let fecha = timeToDate(rowData.END_DATE)
    setUpdateDate_retirement(invDateFormat(fecha))
    setUpdateId(rowData.TERMINATION_ID)
    showModal_();
  }

  async function limpiar() {
    setCodEmpleado("");
    setCalendario("");
    setPdf("")
    setReason_retirement("")
    setDate_end(null)
  }

  async function completarRegistro() {

    setLoadingCreate(true)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _contract_id = codEmpleado;
    const _date_end = dateFormat(date_end);
    const _reason_retirement = reason_retirement.value;
    const _calendario = calendario.value;

    const social_benefits = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      END_DATE: _date_end,
      LOV_REASON: _reason_retirement,
      CONTRACT_ID: _contract_id
    }

    await apis.postSocial_benefits(social_benefits, headers).then(res => {
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Prestación agregada exitosamente', life: 4000 });
      hideModal();
      setTabla();
      limpiar();
      setLoadingCreate(false)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      setLoadingCreate(false)
    })

  }

  async function actualizar() {
    setLoadingUpdate(true)
    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _id_calendar = updateCalendario.value;
    const _contract_id = updateCodEmpleado.value;
    const _date_retirement = dateFormat(updateDate_retirement);
    const _termination_id = updateId;
    const _reason_retirement = updateReason_retirement.value;

    const social_benefits = {
      CLIENT: _client,
      ENTITY: _entity,
      ID_CALENDAR: _id_calendar,
      END_DATE: _date_retirement,
      LOV_REASON: _reason_retirement,
      CONTRACT_ID: _contract_id,
      TERMINATION_ID: _termination_id
    }
    await apis.putSocial_benefits(social_benefits, headers).then(res => {
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
      setIsOpen_(false);
      setLoadingUpdate(false)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      setLoadingUpdate(false)
    })
    setTabla();
  }

  async function eliminar() {

    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _idTermination = deleteId;
    await apis.deleteSocial_benefits(_entity, _cliente, _idTermination, headers).then(res => {
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Registro eliminado con exito', life: 4000 });
      setLoadingDelete(false)
    }).catch(err => {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      setLoadingDelete(false)
    })

    setTabla();
  }

  async function caledanrioLiquidacion(rowData) {
    let _calendario = rowData.ID_CALENDAR.split("|")
    let param = "LD-" + _calendario[0]
    try {
      await apis.getValueListCalendar(param, headers).then(res => {
        let contenido = res.data.CALENDAR
        let calendar = contenido[0]
        setLiquidacion(calendar)
        setListaLiquidacion(contenido)
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
    }
  }

  async function calendarioPlano(rowData) {
    let _calendario = rowData.ID_CALENDAR.split("|")
    let param = localStorage.getItem("client") + "-LD-" + _calendario[0]
    let _entity = localStorage.getItem('entity')
    try {
      await apis.getLastCalendar(_entity, param, headers).then(res => {
        let contenido = res.data.CALENDAR
        console.log(contenido)
        setListaPlanoBancario(contenido)
      })
    }
    catch (err) {
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
    }
  }

  async function updateCalendar(_calendario) {
    /*Función encargada de actualizar el calendario de liquidación de nómina*/
    let param = localStorage.getItem("client") + "-LD-" + _calendario
    let _entity = localStorage.getItem('entity')
    await apis.getLastCalendar(_entity, param, headers).then(res => {
      let calendar = res.data.CALENDAR
      setListaPlanoBancario(calendar)
    })
  }

  const showConfirm = (id, process) => {
    /*Función encargada de mostrar al usuario un mensaje de confirmación de la realización de un proceso*/
    toast.current.show({
      severity: 'success', content: (
        <div className="flex flex-column" style={{ flex: '1' }}>
          <div className="text-center">
            <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: "green" }}></i>
            <p>Proceso {process}({id}) realizado existosamente</p>
          </div>
        </div>
      )
    });
  }

  async function process(action) {
    /*Función encargada de validar cuál proceso se desea realizar*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _calendario = liquidacion.ID_CALENDAR
    const p = {
      ID_CALENDAR: _calendario,
      CLIENT: _cliente,
      ENTITY: _entity,
      ACTION: action
    }
    let msg = ""
    if (action == "PRO") {
      msg = "Procesar"
    }
    else {
      if (action == "CLO") {
        msg = "Acumular"
      }
      else {
        if (action == "REV") {
          msg = "Deshacer"
        }
      }
    }
    try {
      await apis.executeProcess(p, headers).then(res => {
        updateCalendar(_calendario)
      })
      setTimeout(() => {
        apis.getExecutedProcess(_entity, _calendario, _cliente, action, headers).then(res => {
          if (res.data.PROCESS.length > 0) {
            let data = res.data.PROCESS[0]
            console.log(data)
            if (data !== "") {
              let id = data.ID
              showConfirm(id, msg)
            }
            setLoading1(false)
            setLoading2(false)
            setLoading3(false)
          }
          else {
            setLoading1(false)
            setLoading2(false)
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: "No hay registros para el proceso", sticky: true });
          }
        })
        setTablaLogs()
        setTabla()
      }, 1000)
    }
    catch (err) {
      msg = err.response.data.message
      setTablaLogs()
      setLoading1(false)
      setLoading2(false)
      setLoading3(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });
    }
  }

  async function bankFlat() {
    /*Función encargada de gnerar el archivo txt de plano bancario*/
    const client = localStorage.getItem('client')
    const entity = localStorage.getItem('entity')
    const date_pay = dateFormat(fechaPlano)
    const id_last_calendar = plano.ID_CALENDAR
    try {
      await apis.getBankFlat(entity, client, date_pay, id_last_calendar, headers).then(res => {
        let contenido = res.data["FLAT_FILES"]
        let planos = []
        contenido.forEach(file => {
          if (file["DETAIL"].length > 0) {
            let nombre = file.NAME
            let contratos = file.TOTAL_CONTRACT
            let total = file.TOTAL_VALUE
            let lineas = ""
            file["DETAIL"].forEach(element =>
              lineas += element.LINE + "\r\n"
            )
            planos.push({
              nombre,
              contratos,
              total,
              lineas
            })
          }
        })
        setRowsPlano(planos)
        setLoading4(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Plano(s) bancario(s) generado exitosamente" });
        // // hideModalPlano()
        // const blob = new Blob([lineas], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
        // saveAs(blob, nombre);
      })
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const flatDetail = (flat) => {
    const blob = new Blob([flat.lineas], { type: 'text/plain;charset=utf-8;', endings: "transparent" });
    saveAs(blob, flat.nombre);
  }

  const firedReport = async () => {
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      ID_CALENDAR: calendario,
      CONTRACT_ID: codEmpleado
    }
    try {
      await apis.getFiredReport(payload, headers).then(res => {
        let archivo = 'data:application/pdf;base64,' + res.data.PDF[0].DATA
        console.log(archivo)
        setPdf(archivo)
        setLoading7(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Documento de liquidación generado existosamente" });
      })
    }
    catch (err) {
      setLoading7(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const workCertificateReport = async () => {
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      ID_CALENDAR: calendario,
      CONTRACT_ID: codEmpleado
    }
    try {
      await apis.postReportWorkCertificate(payload, headers).then(res => {
        let archivo = 'data:application/pdf;base64,' + res.data.PDF[0].DATA
        console.log(archivo)
        setPdf(archivo)
        setLoading7(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Certificado laboral generado existosamente" });
      })
    }
    catch (err) {
      setLoading7(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const severanceFileReport = async () => {
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      ID_CALENDAR: calendario,
      CONTRACT_ID: codEmpleado
    }
    try {
      await apis.postReportSeveranceFile(payload, headers).then(res => {
        let archivo = 'data:application/pdf;base64,' + res.data.PDF[0].DATA
        console.log(archivo)
        setPdf(archivo)
        setLoading7(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Carta retiro de cesantías generada existosamente" });
      })
    }
    catch (err) {
      setLoading7(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const termitationSupportReport = async () => {
    const payload = {
      ENTITY: localStorage.getItem('entity'),
      CLIENT: localStorage.getItem('client'),
      ID_CALENDAR: calendario,
      CONTRACT_ID: codEmpleado
    }
    try {
      await apis.postReportTerminationSupport(payload, headers).then(res => {
        let archivo = 'data:application/pdf;base64,' + res.data.PDF[0].DATA
        console.log(archivo)
        setPdf(archivo)
        setLoading7(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte liquidación definitiva - Soporte generado existosamente" });
      })
    }
    catch (err) {
      setLoading7(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs mr-2" onClick={() => { showModalEliminar(rowData.TERMINATION_ID) }} />
        <Button label="Liquidar" className=" p-button-sm text-xs mr-2" onClick={() => { showModalLiquidacion(rowData) }} disabled={rowData.STATUS === "CERRADO ACUMULADO"} />
        <Button label="Plano" className="p-button-sm text-xs mr-2" onClick={() => { showModalPlano(rowData) }} />
        {/* <Button icon="pi pi-file-pdf" className="p-button-danger p-button-sm text-xs"
          // disabled={rowData.STATUS === "ACTIVO"}
          tooltip='Documento liquidación' tooltipOptions={{ position: 'top' }}
          onClick={() => { showModalReporte(rowData) }} /> */}
        <SplitButton icon='pi pi-file-pdf' model={items} text={false} onClick={() => setRowReport(rowData)} onShow={() => setRowReport(rowData)} tooltip='Reportes' tooltipOptions={{ position: 'top' }} className='report-button p-button-danger p-button-xs text-sm' menuClassName='novelties'/>
      </div>
    )
  }

  const actionBodyTemplatePlano = (rowData) => {
    return (
      <Button icon="pi pi-download" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Comprobante" tooltipOptions={{ position: 'top' }}
        onClick={() => {
          flatDetail(rowData)
        }} />
    )
  }

  const formatCurrency = (value) => {
    let currency = parseInt(value)
    return currency.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
  };

  const totalBodyTemplatePlano = (rowData) => {
    return formatCurrency(rowData.total);
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="barra">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'LOV_REASON': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];



  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} loading={loadingCreate} label='Guardar'></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar Novedad de retiro</h3>
    </div>
  );

  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} loading={loadingUpdate} label='Guardar'></Button>
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar Novedad de retiro</h3>
    </div>
  );

  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} loading={loadingDelete} label='Si'></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar la Novedad de retiro?</h3>
    </div>
  );

  async function setTablaLogs() {
    /*Función encargada de cargar la  información de la tabla de procesos */
    const _calendario = liquidacion ? liquidacion.ID_CALENDAR : "NULL";
    try {
      await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
        if (res.data["PROCESS"].length > 0) {
          let data = res.data["PROCESS"]
          setRowsLogs(data)
          setRowDataLogs(data)
          setEmployees(res.data.TOTAL_CONTRACT)
          setNet(res.data.TOTAL_REMUNER)
          setConsultado(true)
        }
        else {
          setEmployees("")
          setNet("")
          setRowsLogs([])
          setRowDataLogs([])
        }
        setLoading5(false)
        setLoading6(false)
      })
    }
    catch (err) {
      setLoading5(false)
      setLoading6(false)
    }
  }

  const rowClassName = (rowData) => {
    return { 'error-row': (rowData["STATUS"] === "ERROR") };
  }

  const percentageBodyTemplate = (rowData) => {
    return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  const tableHeader = (
    <div className="table-header flex justify-content-between">
      <div className="flex align-items-center flex-row">
          <i className="pi pi-users mr-2" style={{ fontSize: '1.5rem' }}></i>
          <div className="flex align-items-start flex-column">
              <span className="m-0">Número empleados: {employees}</span>
              <span className="m-0">Neto: {net ? formatCurrency(net) : net}</span>
          </div>
      </div>
      <Button icon="pi pi-refresh" loading={loading6} tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => { setLoading6(true); setTablaLogs() }}
        disabled={loading1 || loading2 || loading3} />
    </div>
  );

  const actionBodyTemplateErrors = (rowData) => {
      console.log(rowData.ERRORS)
    return (
      <div>
        {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
      </div>
    )
  }

  const footerLN = (
    <>
      <div>
        <Button label="Procesar" style={{ marginLeft: "-1rem" }} loading={loading1} onClick={() => { setLoading1(true); process("PRO") }} disabled={!liquidacion || listaLiquidacion.length === 0 || (loading1 || loading2 || loading3)} />
        <Button label="Acumular" loading={loading2} onClick={() => { setLoading2(true); process("CLO") }} disabled={!liquidacion || listaLiquidacion.length === 0 || (loading1 || loading2 || loading3)} />
        <Button label="Deshacer" loading={loading3} onClick={() => { setLoading3(true); process("REV") }} disabled={!liquidacion || listaLiquidacion.length === 0 || (loading1 || loading2 || loading3)} />
      </div>
      {
        consultado === true ?
          <div className="datatable-style-demo">
            <DataTable className="text-xs" header={tableHeader} value={rowsLogs} first={first2Logs} rows={rows2Logs} onPage={onCustomPage2}
              selection={selectedRowsLogs} onSelectionChange={(e) => setSelectedRowsLogs(e.value)} dataKey="ID"
              size="small" filters={filters1Logs} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
              rowClassName={rowClassName}
            >
              <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
              <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
              <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
              <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
              <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
              <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
              <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
              <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
              <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
              <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
              <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
            </DataTable>
          </div>
          : null}
    </>
  );

  const headerLN = (
    <div>
      <h3>Seleccionar calendario para liquidación definitiva</h3>
    </div>
  )

  const footerPB = (
    <div>
      <Button label="Generar" loading={loading4} onClick={() => { setLoading4(true); bankFlat() }} disabled={plano == false || !fechaPlano} />
      {rowsPlano.length > 0 && <DataTable className="text-xs" value={rowsPlano} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
        dataKey="ID" size="small">
        <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
        <Column field="nombre" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Nombre"></Column>
        <Column field="contratos" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Total contratos"></Column>
        <Column field="total" headerStyle={{ width: '12rem', textAlign: 'center' }} header="Valor" body={totalBodyTemplatePlano}></Column>
        <Column header="Documento" headerStyle={{ width: '12rem', textAlign: 'center' }} body={actionBodyTemplatePlano}></Column>
      </DataTable>}
    </div>
  );

  const headerPB = (
    <div>
      <h3>Seleccionar calendario para liquidación plano bancario</h3>
    </div>
  )

  const footerReporte = (
    <div>
      <Button className='mr-2' label="Generar" loading={loading7} onClick={() => { setLoading7(true); firedReport() }} />
      {pdf &&
        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={pdf} downloadName={"liquidacionDefinitiva"+codEmpleado} onDownloadSuccess={() => { setLoading8(false); hideModalReporte() }}>
          <Button className='p-button-danger' icon="pi pi-file-pdf" label="Descargar" loading={loading8} onClick={() => { setLoading8(true) }} />
        </Base64Downloader>
      }
    </div>
  );

  const headerReporte = (
    <div>
      <h3>Documento liquidación definitiva</h3>
    </div>
  )

  const footerReportWorkCertificate = (
    <div>
      <Button className='mr-2' label="Generar" loading={loading7} onClick={() => { setLoading7(true); workCertificateReport() }} />
      {pdf &&
        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={pdf} downloadName={"certificadoLaboral"+codEmpleado} onDownloadSuccess={() => { setLoading8(false); hideModalReportWorkCertificate() }}>
          <Button className='p-button-danger' icon="pi pi-file-pdf" label="Descargar" loading={loading8} onClick={() => { setLoading8(true) }} />
        </Base64Downloader>
      }
    </div>
  );

  const headerReportWorkCertificate = (
    <div>
      <h3>Certificado laboral</h3>
    </div>
  )

  const footerReportSeveranceFile = (
    <div>
      <Button className='mr-2' label="Generar" loading={loading7} onClick={() => { setLoading7(true); severanceFileReport() }} />
      {pdf &&
        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={pdf} downloadName={"cartaRetiroCesantias"+codEmpleado} onDownloadSuccess={() => { setLoading8(false); hideModalReportSeveranceFile() }}>
          <Button className='p-button-danger' icon="pi pi-file-pdf" label="Descargar" loading={loading8} onClick={() => { setLoading8(true) }} />
        </Base64Downloader>
      }
    </div>
  );

  const headerReportSeveranceFile = (
    <div>
      <h3>Carta retiro de cesantías</h3>
    </div>
  )

  const footerReportTerminationSupport = (
    <div>
      <Button className='mr-2' label="Generar" loading={loading7} onClick={() => { setLoading7(true); termitationSupportReport() }} />
      {pdf &&
        <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={pdf} downloadName={"liquidacionDefinitivaSoporte"+codEmpleado} onDownloadSuccess={() => { setLoading8(false); hideModalReportTerminationSupport() }}>
          <Button className='p-button-danger' icon="pi pi-file-pdf" label="Descargar" loading={loading8} onClick={() => { setLoading8(true) }} />
        </Base64Downloader>
      }
    </div>
  );

  const headerReportTerminationSupport = (
    <div>
      <h3>Reporte liquidación definitiva - Soporte</h3>
    </div>
  )

  const netBodyTemplatePlano = (rowData) => {
    if(rowData.TOTAL_REMUNER){
      return formatCurrency(rowData.TOTAL_REMUNER);
    }
    return rowData.TOTAL_REMUNER;
  } 

  return (

    <div>
      <Toast ref={toast} />
      <div className="flex flex-row align-items-center justify-content-center mb-3 mt-6 font-bold text-4xl">
        <span className="text-900">Novedades de retiros</span>
        <Video header="Instructivo retiro de empleado" url={localStorage.getItem('SOCIAL_BENEFITS_VIDEO')} />
      </div>
      <ConfBar style={{ marginTop: "-2rem" }} />
      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">
        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Código empleado</LabelField>
          <Dropdown filter showClear filterBy="label" style={elementWidth} value={codEmpleado} options={listaCodEmpleado} placeholder={"Seleccione un Empleado"}
            onChange={(e) => { setCodEmpleado(e.value); GetCalendar(e.value) }} />
          <LabelField htmlFor="label">Calendario</LabelField>
          <Dropdown filter showClear filterBy="label" style={elementWidth} value={calendario.value} options={listaCalendario}
            placeholder={"Seleccione un Calendario"} onChange={setCalendario} disabled={!codEmpleado} />
          <LabelField htmlFor="label">Motivo del retiro</LabelField>
          <Dropdown filter showClear filterBy="label" style={elementWidth} value={reason_retirement.value} options={listaId_lov_reason}
            placeholder={"Seleccione Motivo del retiro"} onChange={setReason_retirement} disabled={!codEmpleado} />
          <LabelField htmlFor="label">Fecha de retiro</LabelField>
          <Calendar style={elementWidth} id="navigators" value={date_end} onChange={(e) => { setDate_end(e.value) }} locale="es" dateFormat="dd-mm-yy"
            yearRange="2010:2030" showIcon disabled={!codEmpleado} />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">Motivo del retiro</LabelField>
          <Dropdown filter showClear filterBy="label" style={elementWidth} value={updateReason_retirement.value} options={listaId_lov_reason} placeholder={"Motivo del retiro"} onChange={setUpdateReason_retirement} />
          <LabelField className='mt-4' htmlFor="label">Fecha de retiro</LabelField>
          <Calendar style={elementWidth} id="navigators" value={updateDate_retirement} onChange={(e) => { setUpdateDate_retirement(e.value) }} locale="es" dateFormat="dd-mm-yy" yearRange="2010:2030" showIcon />
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <Dialog header={headerReporte} footer={footerReporte} visible={isOpenReporte}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalReporte}>
        </Dialog>

        <Dialog header={headerReportWorkCertificate} footer={footerReportWorkCertificate} visible={isOpenReportWorkCertificate}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalReportWorkCertificate}>
        </Dialog>

        <Dialog header={headerReportSeveranceFile} footer={footerReportSeveranceFile} visible={isOpenReportSeveranceFile}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalReportSeveranceFile}>
        </Dialog>

        <Dialog header={headerReportTerminationSupport} footer={footerReportTerminationSupport} visible={isOpenReportTerminationSupport}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalReportTerminationSupport}>
        </Dialog>

        <Dialog header={headerLN} footer={footerLN} visible={isOpenLiquidacion} maximizable closable={!loading1 && !loading2 && !loading3}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalLiquidacion}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          <LabelField htmlFor="label">Calendario liquidación *</LabelField>
          <div className="p-inputgroup">
            <Dropdown style={elementWidth} value={liquidacion}
              filter showClear filterBy="DETAIL"
              options={listaLiquidacion} placeholder={"Seleccione el calendario"}
              onChange={(e) => {
                setLiquidacion(e.value)
              }}
              optionLabel="DETAIL"
            />
            <Button icon="pi pi-search" loading={loading5} className="mr-2 p-button-sm text-xs" tooltip="Consultar procesos anteriores" tooltipOptions={{ position: 'top' }} onClick={() => { setLoading5(true); setTablaLogs() }}
              disabled={!liquidacion || listaLiquidacion.length === 0 || loading1 || loading2 || loading3} />
          </div>
        </Dialog>
        <Dialog header={headerPB} footer={footerPB} visible={isOpenPlano}
          position="top" style={{ width: "40vw" }} draggable={false} resizable={false} modal onHide={hideModalPlano}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          <div>
            <LabelField htmlFor="label">Calendario liquidación plano bancario *</LabelField>
            <Dropdown style={elementWidth} value={plano}
              filter showClear filterBy="label"
              options={listaPlanoBancario} placeholder={"Seleccione el calendario"}
              onChange={(e) => {
                setPlano(e.value)
              }}
              optionLabel="DETAIL"
            />
          </div>
          <div>
            <LabelField htmlFor="label">Fecha pago plano bancario *</LabelField>
            <Calendar style={elementWidth} id="navigators" value={fechaPlano}
              onChange={(e) => setFechaPlano(e.value)}
              locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaPlano}
              yearRange="2010:2030"
            />
          </div>
        </Dialog>

        <Dialog header={"Errores"} visible={isOpenErrors}
          position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
          <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">
            <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
              <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
            </DataTable>
          </div>
        </Dialog>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} ></Toolbar>
            <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="TERMINATION_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'END_DATE', 'LOV_REASON', 'STATUS']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="TOTAL_CONTRACT" header="Número empleados" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
              <Column field="TOTAL_REMUNER" header="Neto" body={netBodyTemplatePlano} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
              <Column field="END_DATE" body={endDateTemplate} header="Fecha de retiro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha de retiro" sortable></Column>
              <Column field="LOV_REASON" header="Motivo del retiro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Motivo" sortable></Column>
              <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por estado" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>

      </div>

    </div>
  );
}